module.exports = __webpack_public_path__ + "img/体系模型.3c598171.svg";